import React, { useContext, useEffect, useMemo } from 'react';
import { useReporting } from '../hooks/useReporting';

export const ReporterContext = React.createContext()

export const ReporterProvider = ({ children }) => {
    const reportState = useReporting();
    const value = useMemo(() => reportState, [reportState])

    return (
        <ReporterContext.Provider value={value}>
            {children}
        </ReporterContext.Provider>
    );
}

export function useReporterContext() {
    return useContext(ReporterContext)
}